export default "__VITE_ASSET__386fdf5f__"